// extracted by mini-css-extract-plugin
export default {"overlay":"CameraToolOverlay_overlay__3utr2"};